import {
    Search,
    X
} from "lucide-react";

export default function SearchInput({

    value = "",

    onChange,

    placeholder = "Search...",

    autoFocus = false

}){

    return(

        <div className="search-input">

            <Search
                size={18}
                className="search-input-icon"
            />

            <input

                type="text"

                value={value}

                autoFocus={autoFocus}

                placeholder={placeholder}

                onChange={e=>

                    onChange?.(

                        e.target.value

                    )

                }

            />

            {

                value &&

                <button

                    type="button"

                    className="search-clear-btn"

                    onClick={()=>

                        onChange?.("")

                    }

                >

                    <X size={16}/>

                </button>

            }

<style>{`

.search-input{

    flex:1;

    min-width:260px;

    height:46px;

    display:flex;

    align-items:center;

    gap:12px;

    padding:0 14px;

    border:1px solid #D7DCE3;

    border-radius:12px;

    background:#FFFFFF;

    transition:all .2s ease;

}

.search-input:hover{

    border-color:#CBD5E1;

}

.search-input:focus-within{

    border-color:#2563EB;

    box-shadow:

        0 0 0 3px rgba(37,99,235,.12);

}

.search-input-icon{

    color:#94A3B8;

    flex-shrink:0;

}

.search-input input{

    flex:1;

    height:90%;

    border:none;

    outline:none;

    background:transparent;

    font-size:14px;

    color:#0F172A;

}

.search-input input::placeholder{

    color:#94A3B8;

}

.search-clear-btn{

    width:28px;

    height:28px;

    border:none;

    border-radius:50%;

    background:transparent;

    display:flex;

    align-items:center;

    justify-content:center;

    cursor:pointer;

    color:#94A3B8;

    transition:.18s;

}

.search-clear-btn:hover{

    background:#F1F5F9;

    color:#334155;

}

@media(max-width:768px){

.search-input{

    min-width:90%;

}

}

`}</style>

        </div>

    );

}